(function () {
  if (window.ItemManagerSnapModal) {
    return;
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function clamp01(value) {
    var numeric = Number(value);
    if (!Number.isFinite(numeric)) return 0;
    if (numeric < 0) return 0;
    if (numeric > 1) return 1;
    return numeric;
  }

  function formatProductName(value) {
    return String(value || '')
      .replace(/\s*PRE\s*ORDER\s*/gi, ' ')
      .replace(/\s*PREORDER\s*/gi, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function formatCaption(value) {
    return String(value || '')
      .split(/\r?\n/)
      .filter(function (line) {
        return !/^\s*en[\s_-]*neume\s*$/i.test(line);
      })
      .join('\n')
      .replace(/\n{3,}/g, '\n\n')
      .trim();
  }

  // item-manager の basePrice（円単位）専用のフォールバック整形。
  // Shopify product JSON の価格（円×100）は ItemManagerThemeUtils.formatShopifyMoney
  // （÷100）で別処理するため、この関数には渡さないこと。
  function formatPrice(value) {
    var numeric = Number(value);
    if (!Number.isFinite(numeric) || numeric <= 0) return '';
    return '¥' + Math.round(numeric).toLocaleString('ja-JP');
  }

  // 着用アイテムの価格 HTML（modal 用）。商品カテゴリーと同様に、セール時のみ
  // 現在価格をセール色にし、元値（取り消し線）を併記する。バッジ等は付けない。
  // 価格は共通ヘルパー（ItemManagerThemeUtils）で Shopify product JSON から算出。
  function buildModalPriceHtml(priceData) {
    var utils = window.ItemManagerThemeUtils;
    if (!priceData || !utils) return '';
    var current = utils.formatShopifyMoney(priceData.priceCents);
    if (!current) return '';
    if (!priceData.onSale) {
      return '<span class="item-manager-snap-modal__product-price">' + escapeHtml(current) + '</span>';
    }
    var was = utils.formatShopifyMoney(priceData.compareAtCents);
    var currentHtml = '<span class="item-manager-snap-modal__product-price item-manager-snap-modal__product-price--on-sale">' + escapeHtml(current) + '</span>';
    var wasHtml = was
      ? '<span class="item-manager-snap-modal__product-compare-price">' + escapeHtml(was) + '</span>'
      : '';
    return currentHtml + wasHtml;
  }

  // Shopify から価格を取得できない場合（非公開商品・取得失敗）のフォールバック。
  // item-manager の basePrice（円単位）を現在価格として出す（セール表示なし）。
  function buildFallbackPriceHtml(product) {
    var fallback = formatPrice(product.basePrice);
    return fallback
      ? '<span class="item-manager-snap-modal__product-price">' + escapeHtml(fallback) + '</span>'
      : '';
  }

  function formatDateLabel(value) {
    if (!value) return '';
    var date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    var parts = new Intl.DateTimeFormat('ja-JP', {
      timeZone: 'Asia/Tokyo',
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }).formatToParts(date);
    var year = '', month = '', day = '';
    parts.forEach(function (part) {
      if (part.type === 'year') year = part.value;
      else if (part.type === 'month') month = part.value;
      else if (part.type === 'day') day = part.value;
    });
    if (!year || !month || !day) return '';
    return year + '.' + month + '.' + day;
  }

  function normalizeWearingSkuPart(value) {
    var label = String(value || '').trim();
    return label.toUpperCase() === 'ONE SIZE' ? 'ONESIZE' : label;
  }

  function buildWearingSkuLabel(product, hideSize) {
    var parts = [normalizeWearingSkuPart(product.optionValueLabel)];
    if (!hideSize) {
      parts.push(normalizeWearingSkuPart(product.wearingSizeLabel));
    }
    var label = parts.filter(Boolean).join('・');
    return label ? label + '着用' : '';
  }

  function buildProductUrl(product) {
    if (!product || product.isPubliclyVisible === false) return null;
    if (!product.shopifyProductHandle) return null;
    return '/products/' + encodeURIComponent(product.shopifyProductHandle);
  }

  function getCoordinateImages(coordinate) {
    var list = coordinate && Array.isArray(coordinate.images) ? coordinate.images : [];
    return list.filter(function (image) {
      return image && (image.url || image.thumbnailUrl);
    });
  }

  function getStaffName(coordinate) {
    if (!coordinate || !coordinate.staff) return '';
    return coordinate.staff.displayName || coordinate.staff.name || '';
  }

  function getStaffDisplayLabel(coordinate) {
    var staffName = getStaffName(coordinate);
    var heightLabel = coordinate && coordinate.staff ? (coordinate.staff.heightLabel || '') : '';
    if (!staffName) return heightLabel;
    return heightLabel ? staffName + ' / ' + heightLabel : staffName;
  }

  function getStaffAttributesLabel(coordinate) {
    var staff = coordinate && coordinate.staff ? coordinate.staff : {};
    var parts = [];
    if (staff.boneStructureType) parts.push('骨格' + staff.boneStructureType);
    if (staff.baseColor) parts.push(staff.baseColor);
    return parts.join(' / ');
  }

  function isInstagramUrl(value) {
    return /^https?:\/\/(www\.)?instagram\.com\//i.test(String(value == null ? '' : value).trim());
  }

  function getInstagramUrl(coordinate) {
    // EN NEUME: always link to the model's Instagram account (no per-post link).
    // Only honor real instagram.com URLs so a non-Instagram value never links out.
    if (coordinate && coordinate.staff && isInstagramUrl(coordinate.staff.instagramUrl)) {
      return String(coordinate.staff.instagramUrl).trim();
    }
    return '';
  }

  function extractCaptionTags(caption) {
    var matches = String(caption || '').match(/#[^\s#]+/g) || [];
    var seen = {};
    var result = [];
    for (var i = 0; i < matches.length; i += 1) {
      if (!seen[matches[i]]) {
        seen[matches[i]] = true;
        result.push(matches[i]);
        if (result.length >= 12) break;
      }
    }
    return result;
  }

  function create(options) {
    options = options || {};
    var root = options.root;
    if (!root) return null;

    var isCurrentProduct = typeof options.isCurrentProduct === 'function'
      ? options.isCurrentProduct
      : function () { return false; };
    var shouldHideCurrentProductSize = !!options.currentProductHasSingleSize;

    var modalImage = root.querySelector('[data-snap-modal-image]');
    var modalImageTags = root.querySelector('[data-snap-modal-image-tags]');
    var modalThumbnails = root.querySelector('[data-snap-modal-thumbnails]');
    var modalStaff = root.querySelector('[data-snap-modal-staff]');
    var modalAttributes = root.querySelector('[data-snap-modal-attributes]');
    var modalInstagram = root.querySelector('[data-snap-modal-instagram]');
    var modalTitle = root.querySelector('[data-snap-modal-title]');
    var modalDate = root.querySelector('[data-snap-modal-date]');
    var modalCaption = root.querySelector('[data-snap-modal-caption]');
    var modalProducts = root.querySelector('[data-snap-modal-products]');
    var modalCaptionTags = root.querySelector('[data-snap-modal-caption-tags]');
    var modalPrev = root.querySelector('[data-snap-modal-prev]');
    var modalNext = root.querySelector('[data-snap-modal-next]');
    var modalClose = root.querySelector('[data-snap-modal-close-button]');

    if (!modalImage) return null;

    var coordinates = [];
    var activeCoordinateIndex = 0;
    var activeImageIndex = 0;
    var previousActiveElement = null;
    var previousDocumentOverflow = '';
    var keydownListener = null;
    var productsRenderToken = 0;

    function renderModalImageTags(image) {
      if (!modalImageTags) return;
      var tags = image && Array.isArray(image.tags) ? image.tags : [];
      modalImageTags.innerHTML = tags
        .filter(function (tag) {
          return Number.isFinite(Number(tag.posX)) && Number.isFinite(Number(tag.posY));
        })
        .map(function (tag) {
          var left = clamp01(tag.posX) * 100;
          var top = clamp01(tag.posY) * 100;
          return '<span class="item-manager-snap-modal__marker" style="left:' + left + '%;top:' + top + '%;" title="' + escapeHtml(tag.name) + '"></span>';
        })
        .join('');
    }

    function renderModalThumbnails(images) {
      if (!modalThumbnails) return;
      if (images.length <= 1) {
        modalThumbnails.innerHTML = '';
        modalThumbnails.hidden = true;
        return;
      }

      modalThumbnails.hidden = false;
      modalThumbnails.innerHTML = images.map(function (image, index) {
        var src = escapeHtml(image.thumbnailUrl || image.url);
        var alt = escapeHtml(image.altText || '');
        var activeClass = index === activeImageIndex ? ' is-active' : '';
        return '<button type="button" class="item-manager-snap-modal__thumb' + activeClass + '" data-snap-modal-thumb="' + index + '" aria-label="SNAP ' + (index + 1) + '">'
          + '<img src="' + src + '" alt="' + alt + '" loading="lazy" decoding="async">'
          + '</button>';
      }).join('');
    }

    function updateModalImage() {
      var coordinate = coordinates[activeCoordinateIndex];
      var images = getCoordinateImages(coordinate);
      if (images.length === 0) return;

      if (activeImageIndex < 0 || activeImageIndex >= images.length) {
        activeImageIndex = 0;
      }

      var image = images[activeImageIndex];
      var staffName = getStaffName(coordinate);
      modalImage.src = image.url || image.thumbnailUrl;
      modalImage.alt = image.altText || coordinate.title || staffName || 'Staff coordinate';
      renderModalImageTags(image);
      renderModalThumbnails(images);

      var showImageNav = images.length > 1;
      if (modalPrev) modalPrev.hidden = !showImageNav;
      if (modalNext) modalNext.hidden = !showImageNav;
    }

    function renderModalStaff(coordinate) {
      if (!modalStaff) return;
      var staff = coordinate && coordinate.staff ? coordinate.staff : null;
      var staffName = getStaffName(coordinate);
      var heightLabel = staff ? (staff.heightLabel || '') : '';
      if (!staffName && !heightLabel) {
        modalStaff.innerHTML = '';
        modalStaff.hidden = true;
        return;
      }
      var staffId = staff && staff.id ? String(staff.id) : '';
      var nameHtml = '';
      if (staffName) {
        if (staffId) {
          nameHtml = '<a class="item-manager-snap-modal__staff-name item-manager-snap-modal__staff-link" href="/pages/snap?view=snap&staff=' + encodeURIComponent(staffId) + '">' + escapeHtml(staffName) + '</a>';
        } else {
          nameHtml = '<span class="item-manager-snap-modal__staff-name">' + escapeHtml(staffName) + '</span>';
        }
      }
      var heightHtml = heightLabel
        ? '<span class="item-manager-snap-modal__staff-height">' + (staffName ? ' / ' : '') + escapeHtml(heightLabel) + '</span>'
        : '';
      modalStaff.innerHTML = nameHtml + heightHtml;
      modalStaff.hidden = false;
    }

    function renderModalAttributes(coordinate) {
      if (!modalAttributes) return;
      var label = getStaffAttributesLabel(coordinate);
      modalAttributes.textContent = label;
      modalAttributes.hidden = !label;
    }

    function renderModalInstagram(coordinate) {
      if (!modalInstagram) return;
      var url = getInstagramUrl(coordinate);
      if (url) {
        modalInstagram.setAttribute('href', url);
        modalInstagram.hidden = false;
      } else {
        modalInstagram.removeAttribute('href');
        modalInstagram.hidden = true;
      }
    }

    function applyModalProductPrice(index, markup) {
      if (!modalProducts) return;
      var slot = modalProducts.querySelector('[data-snap-price-index="' + index + '"]');
      // 価格が無い場合は空スロットをそのまま残す（DOM 要素を消さない）
      if (slot && markup) slot.outerHTML = markup;
    }

    // カード描画後、各着用アイテムの価格を Shopify product JSON から取得して差し込む。
    // token が最新でない（別コーディネートに切り替わった）場合は反映しない。
    function hydrateModalProductPrices(products, token) {
      var utils = window.ItemManagerThemeUtils;
      products.forEach(function (product, index) {
        var handle = String(product.shopifyProductHandle || '').trim();

        if (!utils || typeof utils.fetchShopifyProduct !== 'function' || !handle) {
          if (token === productsRenderToken) applyModalProductPrice(index, buildFallbackPriceHtml(product));
          return;
        }

        utils.fetchShopifyProduct(handle).then(function (shopifyProduct) {
          if (token !== productsRenderToken) return;
          var priceData = utils.getShopifyDisplayPrice(shopifyProduct);
          var markup = priceData ? buildModalPriceHtml(priceData) : buildFallbackPriceHtml(product);
          applyModalProductPrice(index, markup);
        }).catch(function () {
          if (token !== productsRenderToken) return;
          applyModalProductPrice(index, buildFallbackPriceHtml(product));
        });
      });
    }

    function renderModalProducts(coordinate) {
      if (!modalProducts) return;
      var products = (coordinate.products || []).filter(function (product) {
        return product.nameJa || product.primaryImageUrl;
      });

      if (products.length === 0) {
        modalProducts.innerHTML = '';
        return;
      }

      productsRenderToken += 1;
      var token = productsRenderToken;

      var html = products.map(function (product, index) {
        var url = buildProductUrl(product);
        var tagName = url ? 'a' : 'div';
        var href = url ? ' href="' + escapeHtml(url) + '"' : '';
        var name = formatProductName(product.nameJa || '');
        var hideSize = isCurrentProduct(product) && shouldHideCurrentProductSize;
        var meta = buildWearingSkuLabel(product, hideSize);
        var imageMarkup = product.primaryImageUrl
          ? '<img class="item-manager-snap-modal__product-image" src="' + escapeHtml(product.primaryImageUrl) + '" alt="' + escapeHtml(name) + '" loading="lazy" decoding="async">'
          : '';
        var nameMarkup = name
          ? '<span class="item-manager-snap-modal__product-name">' + escapeHtml(name) + '</span>'
          : '';
        var metaMarkup = meta
          ? '<span class="item-manager-snap-modal__product-meta">' + escapeHtml(meta) + '</span>'
          : '';
        // 価格は Shopify から取得後に差し込む（定価のちらつきを避けるため初期は空のスロット）
        var priceSlot = '<span class="item-manager-snap-modal__product-price-slot" data-snap-price-index="' + index + '"></span>';
        var actionMarkup = url
          ? '<span class="item-manager-snap-modal__product-action">商品を見る</span>'
          : '';

        return '<' + tagName + ' class="item-manager-snap-modal__product"' + href + '>'
          + '<span class="item-manager-snap-modal__product-image-wrap">' + imageMarkup + '</span>'
          + '<span>'
          + nameMarkup
          + metaMarkup
          + priceSlot
          + actionMarkup
          + '</span>'
          + '</' + tagName + '>';
      }).join('');

      modalProducts.innerHTML = '<section class="item-manager-snap-modal__section">'
        + '<h4 class="item-manager-snap-modal__section-title">着用アイテム</h4>'
        + '<div class="item-manager-snap-modal__products">' + html + '</div>'
        + '</section>';

      hydrateModalProductPrices(products, token);
    }

    function renderModalCaptionTags(coordinate) {
      if (!modalCaptionTags) return;
      var tags = extractCaptionTags(coordinate.caption);
      if (tags.length === 0) {
        modalCaptionTags.innerHTML = '';
        return;
      }

      modalCaptionTags.innerHTML = '<section class="item-manager-snap-modal__section">'
        + '<h4 class="item-manager-snap-modal__section-title">タグ</h4>'
        + '<div class="item-manager-snap-modal__caption-tags">'
        + tags.map(function (tag) {
          return '<span class="item-manager-snap-modal__caption-tag">' + escapeHtml(tag) + '</span>';
        }).join('')
        + '</div>'
        + '</section>';
    }

    function renderModal() {
      var coordinate = coordinates[activeCoordinateIndex];
      if (!coordinate) return;

      var images = getCoordinateImages(coordinate);
      var primaryIndex = -1;
      for (var i = 0; i < images.length; i += 1) {
        if (images[i].isPrimary) { primaryIndex = i; break; }
      }
      if (activeImageIndex < 0 || activeImageIndex >= images.length) {
        activeImageIndex = primaryIndex >= 0 ? primaryIndex : 0;
      }

      renderModalStaff(coordinate);
      renderModalAttributes(coordinate);
      renderModalInstagram(coordinate);
      if (modalTitle) modalTitle.textContent = coordinate.title || '';
      if (modalDate) modalDate.textContent = formatDateLabel(coordinate.publishedAt);
      if (modalCaption) modalCaption.textContent = formatCaption(coordinate.caption);
      renderModalProducts(coordinate);
      renderModalCaptionTags(coordinate);
      updateModalImage();
    }

    function open(index) {
      if (!coordinates[index]) return;
      activeCoordinateIndex = index;
      activeImageIndex = -1;
      previousActiveElement = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      previousDocumentOverflow = document.documentElement.style.overflow;
      document.documentElement.style.overflow = 'hidden';
      root.hidden = false;
      renderModal();
      if (modalClose instanceof HTMLElement) {
        modalClose.focus({ preventScroll: true });
      }
      if (!keydownListener) {
        keydownListener = function (event) {
          if (root.hidden) return;
          if (event.key === 'Escape') {
            close();
          } else if (event.key === 'ArrowLeft') {
            showImage(-1);
          } else if (event.key === 'ArrowRight') {
            showImage(1);
          }
        };
        document.addEventListener('keydown', keydownListener);
      }
    }

    function close() {
      if (root.hidden) return;
      root.hidden = true;
      modalImage.removeAttribute('src');
      if (modalImageTags) modalImageTags.innerHTML = '';
      document.documentElement.style.overflow = previousDocumentOverflow;
      if (previousActiveElement) {
        previousActiveElement.focus({ preventScroll: true });
      }
    }

    function showImage(direction) {
      var images = getCoordinateImages(coordinates[activeCoordinateIndex]);
      if (images.length <= 1) return;
      activeImageIndex = (activeImageIndex + direction + images.length) % images.length;
      updateModalImage();
    }

    root.addEventListener('click', function (event) {
      var target = event.target;
      if (!(target instanceof Element)) return;

      if (target.closest('[data-snap-modal-close]')) {
        close();
        return;
      }
      if (target.closest('[data-snap-modal-prev]')) {
        showImage(-1);
        return;
      }
      if (target.closest('[data-snap-modal-next]')) {
        showImage(1);
        return;
      }
      var thumbnail = target.closest('[data-snap-modal-thumb]');
      if (thumbnail) {
        var index = Number.parseInt(thumbnail.getAttribute('data-snap-modal-thumb') || '', 10);
        if (Number.isFinite(index)) {
          activeImageIndex = index;
          updateModalImage();
        }
      }
    });

    function destroy() {
      if (keydownListener) {
        document.removeEventListener('keydown', keydownListener);
        keydownListener = null;
      }
      close();
    }

    function setCoordinates(next) {
      coordinates = Array.isArray(next) ? next : [];
    }

    function updateOptions(next) {
      next = next || {};
      if (typeof next.isCurrentProduct === 'function') {
        isCurrentProduct = next.isCurrentProduct;
      }
      if (typeof next.currentProductHasSingleSize === 'boolean') {
        shouldHideCurrentProductSize = next.currentProductHasSingleSize;
      }
    }

    return {
      open: open,
      close: close,
      setCoordinates: setCoordinates,
      updateOptions: updateOptions,
      destroy: destroy
    };
  }

  window.ItemManagerSnapModal = {
    create: create,
    escapeHtml: escapeHtml,
    clamp01: clamp01,
    formatProductName: formatProductName,
    formatCaption: formatCaption,
    formatPrice: formatPrice,
    formatDateLabel: formatDateLabel,
    buildProductUrl: buildProductUrl,
    getCoordinateImages: getCoordinateImages,
    getStaffName: getStaffName,
    getStaffDisplayLabel: getStaffDisplayLabel,
    getStaffAttributesLabel: getStaffAttributesLabel,
    getInstagramUrl: getInstagramUrl,
    normalizeWearingSkuPart: normalizeWearingSkuPart,
    buildWearingSkuLabel: buildWearingSkuLabel
  };

  document.dispatchEvent(new CustomEvent('item-manager:snap-modal-ready'));
})();
